import { render, staticRenderFns } from "./Audited.vue?vue&type=template&id=37b8c465&scoped=true"
import script from "./Audited.vue?vue&type=script&lang=js"
export * from "./Audited.vue?vue&type=script&lang=js"
import style0 from "./Audited.vue?vue&type=style&index=0&id=37b8c465&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b8c465",
  null
  
)

export default component.exports